// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2sHst","cta":"Button_cta__SkIxM"};